export enum DealPriceType {
  /**
   * 最高价
   */
  HIGHEST = 0,

  /**
   * 平均价
   */
  AVERAGE = 1
}

export const DealPriceTypeTextMap = {
  [DealPriceType.HIGHEST]: '最高价',
  [DealPriceType.AVERAGE]: '平均价'
}
